import { Provider } from './provider';
import { Logger } from '../logger';
import { ErrorView } from '../view/error-view';

declare const process: any;

export class HubspotProvider extends Provider {

    constructor() {
        super();
    }

    errorView: ErrorView = new ErrorView();
    logger: Logger = {} as Logger;

    getContactById(portalId: string, contactId: string, fields: string[]) {
        const url = `${process.env.API_URL}proxy/v2/contact_id/${portalId}/${contactId}${this.arrayToProperties(fields)}`;
        return this.fetch(this.fixPropertiesQueryParam(url));
    }

	/**
	 * @deprecated Use {@link #getDealV3ById}.
	 */
    getDealById(portalId: string, dealId: string, fields: string[]) {
        const url = `${process.env.API_URL}proxy/${portalId}/deals/${dealId}${this.arrayToProperties(fields)}`;
        return this.fetch(this.fixPropertiesQueryParam(url));
    }
    
    getDealV3ById(portalId: string, dealId: string, fields: string[]) {
        const url = `${process.env.API_URL}proxy/${portalId}/deals/v3/${dealId}${this.arrayToProperties(fields)}`;
        return this.fetch(this.fixPropertiesQueryParam(url));
    }

    arrayToProperties(fields: string[]){
        return `?properties=${fields.join(',')}`;
    }

    /**
     * It might happen that some query parameters from the page are appended to the URL,
     * thus we need to prepand the correct prefix to "properties" query parameter.
     */
    fixPropertiesQueryParam(url: string): string {
        return (url.includes('?properties=') && url.indexOf('?') !== url.lastIndexOf('?')) ?
        url.replace('?properties=', '&properties=') :
        url;
    }

    getFormConfig(portalId: String, formId: String): Promise<any> {
        return this.fetch(`https://forms.hsforms.com/embed/v3/form/${portalId}/${formId}/json?hs_static_app=forms-embed`);
    }

}
